/**
 * FRONT-199/221/2343: whether this session's turn is currently "active" —
 * either a live local stream (submitted/streaming) OR a server-side run with
 * no live stream attached here (`backgroundActive`, e.g. a chat surface
 * reopened mid-run). `ChatMessages` (chat-messages.tsx) uses this same
 * boolean for two things that must never drift apart: the last user bubble's
 * "…in progress" chip, and the `pollWhile` option on its `useChatStatuses`
 * call (which keeps the 2s chat-status poll, and the cross-replica approval
 * reconcile riding on it, running for a turn already known to be in flight
 * locally — see use-chat-status.ts's `chatStatusesQueryOptions` docblock).
 * Pulled out as its own pure function so both uses read one value, and so it
 * can be swept over status × backgroundActive without rendering anything.
 */
export function isTurnActive(status: string, backgroundActive?: boolean): boolean {
  return status === 'streaming' || status === 'submitted' || backgroundActive === true;
}
